'use client';

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, MapPin, User } from 'lucide-react';
import { useUser } from '@/contexts/UserContext';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';

const SearchHeader = () => {
  const { user } = useUser();
  const userRole = user?.userType;
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    // Implement search functionality
    console.log('Searching for:', searchQuery);
  };

  const userAddress = user?.addressModel?.[0];
  const addressDisplay = userAddress
    ? `${userAddress.sector}, ${userAddress.city}`
    : 'Set your location';

  return (
    <header className="bg-white sticky w-full max-w-md border-l border-r top-0 z-30">
      <div className="max-w-md mx-auto">
        <div className="flex flex-col px-4 pt-2 pb-2">
          {/* Top row with logo, location and profile */}
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center">
              <div className="text-xl text-green-700 font-bold">
                <img
                  src="/images/biglocallogo3.png"
                  alt="SubziWale Logo"
                  className="w-32 object-contain"
                  loading="eager"
                />
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Link to={userRole === 'vendor' ? '/vendor/profile' : '/profile'}>
                <div className="h-9 w-9 rounded-full bg-green-700 text-white flex items-center justify-center font-medium">
                  {user?.name?.slice(0, 1) === '+' ? (
                    <User className="w-5 h-5" />
                  ) : (
                    user?.name?.slice(0, 1) || <User className="w-5 h-5" />
                  )}
                </div>
              </Link>
            </div>
          </div>

          {/* Search bar */}
          {/* <form onSubmit={handleSearch} className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <input
              type="text"
              placeholder="Search for vegetables, fruits..."
              className="w-full h-10 pl-10 pr-4 rounded-full border border-gray-200 focus:outline-none focus:ring-1 focus:ring-green-500 text-sm"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form> */}
        </div>
      </div>
    </header>
  );
};

export default SearchHeader;
